module.exports = __webpack_public_path__ + "static/media/branding-logo.e487f873.png";